export default __webpack_public_path__ + "static/media/gallery-wip-handle_03.90ec26d8.jpg";